import React, { Suspense } from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import { I18nextProvider } from "react-i18next";
import { Inspector } from "react-inspect-overlay";

import { i18n, api } from "@/services";
import { configure as configureStore } from "@/store";
import Routes from "./routes";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

import "swiper/css";
import "@/assets/styles/tailwind.css";
import "@/assets/styles/main.scss";
import "@/assets/styles/fonts.css";
import "@/assets/styles/style.scss";
import "@/assets/styles/normalize.css";

if (import.meta.env.PROD) {
  console.log = () => {};
  console.debug = () => {};
  console.info = () => {};
}

const store = configureStore();
store.subscribe(() => {
  api.subscribe(store);
});
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      refetchOnMount: true,
      retryDelay: (attemptIndex) => Math.min(1000 * 2 ** attemptIndex, 30000),
      retry: false,
    },
  },
});

const render = (Component) => {
  ReactDOM.render(
    <QueryClientProvider client={queryClient}>
      <Provider {...{ store }}>
        <Suspense fallback="">
          <I18nextProvider i18n={i18n()}>
            <Component {...{ store }} />
          </I18nextProvider>
          {import.meta.env.DEV && <Inspector />}
        </Suspense>
      </Provider>
    </QueryClientProvider>,
    document.getElementById("root")
  );
};

render(Routes);

if (import.meta.hot) {
  import.meta.hot.accept("./routes", (mod) => {
    render(mod.default);
  });
}
